module.exports = __webpack_public_path__ + "static/media/loginimg.71505bb4.png";